import { RestClient } from '@/api/rest-client'
import { Referral } from '@/api/model/referral'
import { OrderCount } from '@/api/model/order-count'

export class OrderCountClient extends RestClient<Referral> {
    collectionName = 'orders'

    async getOrderCount(myOrders: boolean, assignedOrders: boolean): Promise<OrderCount> {
        const response = await this.client.post(`${this.basePath}/${this.collectionName}/count`, {
            owner: myOrders ? 'user' : 'team',
            type: assignedOrders ? 'assigned' : 'created',
        })

        return OrderCount.fromData(response.data)
    }
}
